<template>
  <div id="LayerOut" class="bg1">
    <div id="apDiv2">
      <input
        :value="aBill.a2"
        name="A[0].a2"
        cname="a2"
        style="font-weight: bold; color: blue; color: blue"
        class="isNumeric"
      />
    </div>
    <div id="apDiv3">
      <input :value="aBill.a3" name="A[0].a3" cname="a3" style="font-weight: bold; color: blue" class="isNumeric" />
    </div>
    <div id="apDiv4">
      <input :value="aBill.a4" name="A[0].a4" cname="a4" style="font-weight: bold; color: blue" class="isNumeric" />
    </div>
    <div id="apDiv5">
      <input
        :value="aBill.a5"
        name="A[0].a5"
        cname="a5"
        style="font-weight: bold; text-align: left; color: red; font-size: 18px"
      />
    </div>
    <div id="apDiv6">
      <input :value="aBill.a6" name="A[0].a6" cname="a6" style="font-weight: bold; color: blue; text-align: left" />
    </div>
    <div id="apDiv8">
      <input :value="aBill.a8" name="A[0].a8" cname="a8" style="font-weight: bold; color: blue; text-align: left" />
    </div>
    <div id="apDiv9">
      <input :value="aBill.a9" name="A[0].a9" cname="a9" style="font-weight: bold; color: blue; text-align: left" />
    </div>

    <div v-for="(tableCells, i) in bDataList" :key="i">
      <div :id="'apDiv'+(i*7+10+j)" v-for="(cell, j) in tableCells.data" :key="j">
        <input :value="cell" style="text-align: left; font-weight: bold; color: blue" />
      </div>
    </div>

    <div id="apDiv38">
      <input :value="aBill.a24" name="A[0].a24" cname="a24" style="text-align: left; font-weight: bold; color: blue" />
    </div>
    <div id="apDiv39">
      <input
        :value="aBill.a25"
        name="A[0].a25"
        cname="a25"
        style="text-align: right; font-weight: bold; color: blue"
        class="isNumeric"
      />
    </div>
    <div id="apDiv40">
      <input
        :value="aBill.a26"
        name="A[0].a26"
        cname="a26"
        style="text-align: right; font-weight: bold; color: blue"
        class="isNumeric"
      />
    </div>
    <div id="apDiv41">
      <input
        :value="aBill.a27"
        name="A[0].a27"
        cname="a27"
        class="isNumeric"
        style="text-align: right; font-weight: bold; color: blue"
      />
    </div>
    <div id="apDiv42">
      <input
        :value="aBill.a20"
        name="A[0].a20"
        cname="a20"
        class="isNumeric"
        style="text-align: right; font-weight: bold; color: blue"
      />
    </div>
    <div id="apDiv43">
      <input :value="aBill.a10" name="A[0].a10" cname="a10" style="font-weight: bold; color: blue" />
    </div>
    <div id="apDiv44">
      <input :value="aBill.a11" name="A[0].a11" cname="a11" style="font-weight: bold; color: blue" />
    </div>
    <div id="apDiv45">
      <input :value="aBill.a12" name="A[0].a12" cname="a12" style="font-weight: bold; color: blue" />
    </div>
    <div id="apDiv46">
      <input :value="aBill.a13" name="A[0].a13" cname="a13" style="font-weight: bold; color: blue" />
    </div>
    <div id="apDiv47">
      <span style="color: #fe0104"></span>
    </div>
    <div id="apDiv48">
      <span style="color: #fe0104"></span>
    </div>
    <div id="apDiv49">
      <span style="color: #fe0104"></span>
    </div>
    <div id="apDiv50">
      <span style="color: #fe0104"></span>
    </div>
  </div>
</template>

<script>
import { environment } from '@/utils/oss.env'
export default {
  props: {
    bgDatas: { type: Array, default: () => [] },
  },
  data() {
    return {
      aBill: [],
      cachetDate: [],
      aDataList: [],
      bDataList: [],
    }
  },
  mounted() {
    this.initABData()
  },
  methods: {
    initABData() {
      let bData = {}
      const cacheList = []
      const bDataList = []
      const aDataList = []
      for (const index in this.bgDatas) {
        if (this.bgDatas[index]['a'] !== undefined) {
          bData = {}
          this.aBill = this.bgDatas[index]['a']
        } else if (this.bgDatas[index]['c'] !== undefined) {
          const cl = this.bgDatas[index]['c']
          for (const jIndex in cl) {
            const c = cl[jIndex]
            bData = {}
            const t = { imgUrl: '', x: '', y: '' }
            t.imgUrl = environment.cacheUrl + c.imgUrl
            t.x = c.x + 'px'
            t.y = c.y + 'px'
            cacheList.push(t)
          }
        } else if (this.bgDatas[index]['b'] !== undefined) {
          const bl = this.bgDatas[index]['b']
          for (const jIndex in bl) {
            const b = bl[jIndex]
            bData = {}
            const t = []
            t.push(b.b1)
            t.push(b.b2)
            t.push(b.b3)
            t.push(b.b4)
            t.push(b.b5)
            t.push(b.b6)
            t.push(b.b7)
            bData['data'] = t
            bDataList.push(bData)
          }
        }
        this.bDataList = bDataList
        this.aDataList = aDataList
        this.cachetDate = cacheList
        console.log(bDataList)
        console.log(aDataList)
        console.log(cacheList)
      }
    },
  },
}
</script>

<style lang="less" scoped>
.bg1 {
  /*background: url('/odiv/odiv_rkd000_rkd/V1/odiv_rkd000_rkd1.jpg?x-oss-process=style/sc-common');*/
  background: url('~@/assets/odiv_rkd000_rkd1.jpg');
  position: absolute;
  z-index: 1;
  width: 850px;
  height: 400px;
  top: 0px;
  left: 0px;
  clear: both;
}
.bg2 {
  /* background: url('/odiv/odiv_rkd000_rkd/V1/odiv_rkd000_rkd2.jpg?x-oss-process=style/sc-common');*/
  position: absolute;
  z-index: 1;
  width: 850px;
  height: 400px;
  top: 0px;
  left: 0px;
  clear: both;
}
.bg3 {
  /* background: url('/odiv/odiv_rkd000_rkd/V1/odiv_rkd000_rkd3.jpg?x-oss-process=style/sc-common');*/
  position: absolute;
  z-index: 1;
  width: 850px;
  height: 400px;
  top: 0px;
  left: 0px;
  clear: both;
}
body {
  font-family: Verdana;
  font-size: 12px;
  margin-left: 0px;
  margin-top: 0px;
  margin-right: 0px;
  margin-bottom: 0px;
  background-color: #fbfbfb;
  padding-left: 10px;
}
#LayerOut {
  position: relative;
  top: 0;
  left: 0;
  z-index: 0;
  width: 850px;
  height: 400px;
}
#LayerOut input {
  width: 95%;
  height: 100%;
}
#apDiv2 {
  height: 20px;
  left: 353px;
  position: absolute;
  top: 82px;
  width: 34px;
  z-index: 1;
}
#apDiv3 {
  height: 20px;
  left: 406px;
  position: absolute;
  top: 82px;
  width: 30px;
  z-index: 1;
}
#apDiv4 {
  height: 20px;
  left: 452px;
  position: absolute;
  top: 82px;
  width: 28px;
  z-index: 1;
}
#apDiv5 {
  height: 20px;
  left: 696px;
  position: absolute;
  top: 80px;
  width: 100px;
  z-index: 1;
}
#apDiv6 {
  height: 40px;
  left: 100px;
  position: absolute;
  top: 114px;
  width: 190px;
  z-index: 1;
}
#apDiv8 {
  height: 40px;
  left: 368px;
  position: absolute;
  top: 114px;
  width: 155px;
  z-index: 1;
}
#apDiv9 {
  height: 40px;
  left: 585px;
  position: absolute;
  top: 114px;
  width: 205px;
  z-index: 1;
}
#apDiv10 {
  height: 20px;
  left: 35px;
  position: absolute;
  top: 211px;
  width: 46px;
  z-index: 1;
}
#apDiv11 {
  height: 20px;
  left: 90px;
  position: absolute;
  top: 211px;
  width: 280px;
  z-index: 1;
}
#apDiv12 {
  height: 20px;
  left: 377px;
  position: absolute;
  top: 211px;
  width: 60px;
  z-index: 1;
}
#apDiv13 {
  height: 20px;
  left: 440px;
  position: absolute;
  top: 211px;
  width: 72px;
  z-index: 1;
}
#apDiv14 {
  height: 20px;
  left: 520px;
  position: absolute;
  top: 211px;
  width: 70px;
  z-index: 1;
}
#apDiv15 {
  height: 20px;
  left: 604px;
  position: absolute;
  top: 211px;
  width: 75px;
  z-index: 1;
}
#apDiv16 {
  height: 20px;
  left: 684px;
  position: absolute;
  top: 211px;
  width: 110px;
  z-index: 1;
}
#apDiv17 {
  height: 20px;
  left: 35px;
  position: absolute;
  top: 231px;
  width: 46px;
  z-index: 1;
}
#apDiv18 {
  height: 20px;
  left: 90px;
  position: absolute;
  top: 231px;
  width: 280px;
  z-index: 1;
}
#apDiv19 {
  height: 20px;
  left: 377px;
  position: absolute;
  top: 231px;
  width: 60px;
  z-index: 1;
}
#apDiv20 {
  height: 20px;
  left: 440px;
  position: absolute;
  top: 231px;
  width: 72px;
  z-index: 1;
}
#apDiv21 {
  height: 20px;
  left: 520px;
  position: absolute;
  top: 231px;
  width: 70px;
  z-index: 1;
}
#apDiv22 {
  height: 20px;
  left: 604px;
  position: absolute;
  top: 231px;
  width: 75px;
  z-index: 1;
}
#apDiv23 {
  height: 20px;
  left: 684px;
  position: absolute;
  top: 231px;
  width: 110px;
  z-index: 1;
}
#apDiv24 {
  height: 20px;
  left: 35px;
  position: absolute;
  top: 251px;
  width: 46px;
  z-index: 1;
}
#apDiv25 {
  height: 20px;
  left: 90px;
  position: absolute;
  top: 251px;
  width: 280px;
  z-index: 1;
}
#apDiv26 {
  height: 20px;
  left: 377px;
  position: absolute;
  top: 251px;
  width: 60px;
  z-index: 1;
}
#apDiv27 {
  height: 20px;
  left: 440px;
  position: absolute;
  top: 251px;
  width: 72px;
  z-index: 1;
}
#apDiv28 {
  height: 20px;
  left: 520px;
  position: absolute;
  top: 251px;
  width: 70px;
  z-index: 1;
}
#apDiv29 {
  height: 20px;
  left: 604px;
  position: absolute;
  top: 251px;
  width: 75px;
  z-index: 1;
}
#apDiv30 {
  height: 20px;
  left: 684px;
  position: absolute;
  top: 251px;
  width: 110px;
  z-index: 1;
}
#apDiv31 {
  height: 20px;
  left: 35px;
  position: absolute;
  top: 273px;
  width: 46px;
  z-index: 1;
}
#apDiv32 {
  height: 20px;
  left: 90px;
  position: absolute;
  top: 273px;
  width: 280px;
  z-index: 1;
}
#apDiv33 {
  height: 20px;
  left: 377px;
  position: absolute;
  top: 273px;
  width: 60px;
  z-index: 1;
}
#apDiv34 {
  height: 20px;
  left: 440px;
  position: absolute;
  top: 273px;
  width: 72px;
  z-index: 1;
}
#apDiv35 {
  height: 20px;
  left: 520px;
  position: absolute;
  top: 273px;
  width: 70px;
  z-index: 1;
}
#apDiv36 {
  height: 20px;
  left: 604px;
  position: absolute;
  top: 273px;
  width: 75px;
  z-index: 1;
}
#apDiv37 {
  height: 20px;
  left: 684px;
  position: absolute;
  top: 273px;
  width: 110px;
  z-index: 1;
}
#apDiv38 {
  height: 20px;
  left: 377px;
  position: absolute;
  top: 294px;
  width: 60px;
  z-index: 1;
}
#apDiv39 {
  height: 20px;
  left: 440px;
  position: absolute;
  top: 294px;
  width: 72px;
  z-index: 1;
}
#apDiv40 {
  height: 20px;
  left: 520px;
  position: absolute;
  top: 294px;
  width: 70px;
  z-index: 1;
}
#apDiv41 {
  height: 20px;
  left: 604px;
  position: absolute;
  top: 294px;
  width: 75px;
  z-index: 1;
}
#apDiv42 {
  height: 20px;
  left: 684px;
  position: absolute;
  top: 294px;
  width: 110px;
  z-index: 1;
}
#apDiv43 {
  height: 20px;
  left: 187px;
  position: absolute;
  top: 325px;
  width: 100px;
  z-index: 1;
}
#apDiv44 {
  height: 20px;
  left: 374px;
  position: absolute;
  top: 325px;
  width: 100px;
  z-index: 1;
}
#apDiv45 {
  height: 20px;
  left: 540px;
  position: absolute;
  top: 325px;
  width: 100px;
  z-index: 1;
}
#apDiv46 {
  height: 20px;
  left: 710px;
  position: absolute;
  top: 325px;
  width: 80px;
  z-index: 1;
}
#apDiv47 {
  height: 20px;
  left: 75px;
  position: absolute;
  top: 320px;
  width: 60px;
  z-index: 1;
}
#apDiv48 {
  height: 20px;
  left: 270px;
  position: absolute;
  top: 320px;
  width: 60px;
  z-index: 1;
}
#apDiv49 {
  height: 20px;
  left: 455px;
  position: absolute;
  top: 320px;
  width: 50px;
  z-index: 1;
}
#apDiv50 {
  height: 20px;
  left: 650px;
  position: absolute;
  top: 320px;
  width: 50px;
  z-index: 1;
}
INPUT {
  font-family: '楷体_GB2312', '楷体';
  font-size: 12px;
  font-weight: bold;
  background-color: transparent;
  background: none;
  letter-spacing: 0px;
  word-spacing: normal;
  border: 1px none #cccccc;
  overflow: hidden;
  width: 100%;
  line-height: 18px;
}
</style>
